'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var reactCountup = require('react-countup');
require('../../icons/AccountAdd.js');
require('../../icons/AccountCheck.js');
require('../../icons/AccountRemove.js');
require('../../icons/AccountStar.js');
require('../../icons/Account.js');
require('../../icons/ArrowCollapse.js');
require('../../icons/ArrowDownDrop.js');
require('../../icons/ArrowExpand.js');
require('../../icons/ArrowLeftDrop.js');
require('../../icons/ArrowLeft.js');
require('../../icons/ArrowRightDrop.js');
require('../../icons/Bell.js');
require('../../icons/BullhornOutline.js');
require('../../icons/BurgerMenu.js');
require('../../icons/CalendarDetailed.js');
require('../../icons/CalendarOutline.js');
require('../../icons/CashOff.js');
require('../../icons/Cash.js');
require('../../icons/CautionDecagram.js');
require('../../icons/CautionOutline.js');
require('../../icons/CheckCircled.js');
require('../../icons/CheckDecagram.js');
require('../../icons/CheckOutlinedCircled.js');
require('../../icons/Check.js');
require('../../icons/ChevronDown.js');
require('../../icons/ChevronLeft.js');
require('../../icons/ChevronRight.js');
require('../../icons/ChevronUp.js');
require('../../icons/CircleOutline.js');
require('../../icons/ClipboardTextOutline.js');
require('../../icons/Clock.js');
require('../../icons/CloseCircleFilled.js');
require('../../icons/Close.js');
require('../../icons/CompareArrows.js');
var Corner = require('../../icons/Corner.js');
require('../../icons/Critical.js');
require('../../icons/Delete.js');
require('../../icons/DocumentEditCircled.js');
require('../../icons/DocumentEditOutline.js');
require('../../icons/DotsVertical.js');
require('../../icons/DownloadFilled.js');
require('../../icons/Draft.js');
require('../../icons/Encryption.js');
require('../../icons/EuroOff.js');
require('../../icons/Euro.js');
require('../../icons/EyeOff.js');
require('../../icons/Eye.js');
require('../../icons/FlagCheckered.js');
require('../../icons/FwSet0Constructionyear1.js');
require('../../icons/FwSet0Constructionyear2.js');
require('../../icons/FwSet0Constructionyear3.js');
require('../../icons/FwSet0Constructionyear4.js');
require('../../icons/FwSet0Corner.js');
require('../../icons/FwSet0Corneretc.js');
require('../../icons/FwSet0CultivableLimited.js');
require('../../icons/FwSet0CultivableNo.js');
require('../../icons/FwSet0CultivableUnsure.js');
require('../../icons/FwSet0Cultivable.js');
require('../../icons/FwSet0ElevatorNo.js');
require('../../icons/FwSet0Elevator.js');
require('../../icons/FwSet0Flat.js');
require('../../icons/FwSet0Garage.js');
require('../../icons/FwSet0House.js');
require('../../icons/FwSet0IndustryDontKnow.js');
require('../../icons/FwSet0IndustryIndustry.js');
require('../../icons/FwSet0IndustryLiveBusiness.js');
require('../../icons/FwSet0IndustryOffice.js');
require('../../icons/FwSet0Industry.js');
require('../../icons/FwSet0KitchenNew.js');
require('../../icons/FwSet0KitchenNo.js');
require('../../icons/FwSet0KitchenOld.js');
require('../../icons/FwSet0LandDevelopmentFull.js');
require('../../icons/FwSet0LandDevelopmentInPart.js');
require('../../icons/FwSet0LandDevelopmentNo.js');
require('../../icons/FwSet0Level1.js');
require('../../icons/FwSet0Level2.js');
require('../../icons/FwSet0Level3.js');
require('../../icons/FwSet0Levelplus.js');
require('../../icons/FwSet0LivingspaceUnknown.js');
require('../../icons/FwSet0Livingspace100.js');
require('../../icons/FwSet0Livingspace200.js');
require('../../icons/FwSet0Livingspace200Plus.js');
require('../../icons/FwSet0ParkingNo.js');
require('../../icons/FwSet0Parking.js');
require('../../icons/FwSet0PlotUnknown.js');
require('../../icons/FwSet0Plot.js');
require('../../icons/FwSet0Plot1000.js');
require('../../icons/FwSet0Plot1000Plus.js');
require('../../icons/FwSet0Plot300.js');
require('../../icons/FwSet0Rooms.js');
require('../../icons/FwSet0SemiDetached.js');
require('../../icons/FwSet0TownhouseCorner.js');
require('../../icons/FwSet0TownhouseMiddle.js');
require('../../icons/GiftCircled.js');
require('../../icons/Hausgold.js');
require('../../icons/HelpOutline.js');
require('../../icons/Help.js');
require('../../icons/HomeOutline.js');
require('../../icons/HouseCircled.js');
require('../../icons/HousePerson.js');
var House = require('../../icons/House.js');
var Industry = require('../../icons/Industry.js');
require('../../icons/InfoFilled.js');
require('../../icons/InfoOutline.js');
require('../../icons/LabelPercent.js');
var Level2 = require('../../icons/Level2.js');
require('../../icons/LightbulbOn.js');
require('../../icons/LockCircledOutline.js');
require('../../icons/Lock.js');
require('../../icons/Magnifier.js');
require('../../icons/Mail.js');
require('../../icons/Map.js');
require('../../icons/MissingOutline.js');
require('../../icons/OkCircled.js');
require('../../icons/OpenBookOutline.js');
require('../../icons/PageFirst.js');
require('../../icons/PageLast.js');
require('../../icons/Pause.js');
require('../../icons/Pen.js');
require('../../icons/Percent.js');
require('../../icons/PhoneCircled.js');
require('../../icons/Phone.js');
require('../../icons/PiggyBankCircled.js');
require('../../icons/PiggyBank.js');
require('../../icons/Plus.js');
require('../../icons/PremiumStars.js');
require('../../icons/Printer.js');
require('../../icons/RealtyCommercial.js');
require('../../icons/RealtyFlat.js');
require('../../icons/RealtyHouse.js');
require('../../icons/RealtySite.js');
require('../../icons/Rocket.js');
require('../../icons/Rooms.js');
require('../../icons/SpeechBubble.js');
require('../../icons/SpeechBubbles.js');
require('../../icons/Speedometer.js');
require('../../icons/Star.js');
require('../../icons/StatusDontknow.js');
require('../../icons/SwapHorizontalBold.js');
require('../../icons/ThumbDownOutline.js');
require('../../icons/ThumbUpOutline.js');
require('../../icons/TruckFastOutline.js');
require('../../icons/UnorderedList.js');
require('../../icons/User.js');
var mask = require('./mask.svg.js');
require('../../illustrations/BrokerRatingSuccess.js');
require('../../illustrations/BrokerRating.js');
require('../../illustrations/Documents.js');
require('../../illustrations/EmptyFinance.js');
require('../../illustrations/EmptyFinanceWithAvatar.js');
require('../../illustrations/EmptyMessenger.js');
require('../../illustrations/EmptyReaprofile.js');
require('../../illustrations/EmptyStatistics.js');
require('../../illustrations/Logic.js');
require('../../illustrations/MoneyExchange.js');
require('../../illustrations/PropertyMoney.js');
var PropertySold = require('../../illustrations/PropertySold.js');
require('../../illustrations/RealtyTypeApartment.js');
require('../../illustrations/RealtyTypeCommercial.js');
require('../../illustrations/RealtyTypeHouse.js');
require('../../illustrations/RealtyTypeOther.js');
require('../../illustrations/RealtyTypeSite.js');
require('../../illustrations/RobotCircled.js');
require('../../illustrations/Robot.js');
require('../../illustrations/ThoughtProcess.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["type"],
  _excluded2 = ["percentage", "type", "size", "animationDuration"];

// `CIRCLE_RADIUS` should NEVER be changed as long as the mask SVG itself doesn't change. It is only a constant to make sure
// the value is the same everywhere.
var CIRCLE_RADIUS = 38.5;
// .. same with `CIRCUMFERENCE`.
var CIRCUMFERENCE = CIRCLE_RADIUS * 2 * Math.PI;
var PropertyType;
(function (PropertyType) {
  PropertyType["PROPERTY"] = "property";
  PropertyType["HOUSE"] = "house";
  PropertyType["APARTMENT"] = "apartment";
  PropertyType["INDUSTRY"] = "industry";
})(PropertyType || (PropertyType = {}));
var PropertyProgressIcon = function PropertyProgressIcon(_ref) {
  var type = _ref.type,
    rest = _objectWithoutProperties__default["default"](_ref, _excluded);
  switch (type) {
    case 'house':
      return /*#__PURE__*/React__default["default"].createElement(House.House, rest);
    case 'apartment':
      return /*#__PURE__*/React__default["default"].createElement(Level2.Level2, rest);
    case 'industry':
      return /*#__PURE__*/React__default["default"].createElement(Industry.Industry, rest);
    case 'property':
      return /*#__PURE__*/React__default["default"].createElement(Corner.Corner, rest);
    default:
      return /*#__PURE__*/React__default["default"].createElement(House.House, rest);
  }
};
/**
 * PropertyProgressIndicator
 *
 * Shows the progress (in context of filling out information) for a property with an animated circle and icon.
 */
var PropertyProgressIndicator = react.forwardRef(function (props, ref) {
  var _props$percentage = props.percentage,
    percentage = _props$percentage === void 0 ? 0 : _props$percentage,
    _props$type = props.type,
    type = _props$type === void 0 ? PropertyType.HOUSE : _props$type,
    _props$size = props.size,
    size = _props$size === void 0 ? '93px' : _props$size,
    _props$animationDurat = props.animationDuration,
    animationDuration = _props$animationDurat === void 0 ? 2 : _props$animationDurat,
    rest = _objectWithoutProperties__default["default"](props, _excluded2);
  var humanReadablePercentage = React.useMemo(function () {
    return percentage >= 1 ? percentage : percentage * 100;
  }, [percentage]);
  var _useState = React.useState(CIRCUMFERENCE),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    strokeProgress = _useState2[0],
    setStrokeProgress = _useState2[1];
  var _useCountUp = reactCountup.useCountUp({
      start: 0,
      end: humanReadablePercentage,
      suffix: '%',
      duration: animationDuration
    }),
    value = _useCountUp.countUp,
    update = _useCountUp.update;

  // Update the count and stroke progress when `percentage` changes
  React.useEffect(function () {
    update(humanReadablePercentage);

    // Set the new stroke progress (stroke-dashoffset)
    // See: https://css-tricks.com/building-progress-ring-quickly/
    setStrokeProgress(CIRCUMFERENCE - humanReadablePercentage / 100 * CIRCUMFERENCE);
  }, [update, humanReadablePercentage]);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref
  }, rest, {
    className: utils.cx('chakra-property-progress-indicator', props.className)
  }), /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
    __css: {
      boxSize: size,
      display: 'flex',
      pos: 'relative',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, percentage === 100 && /*#__PURE__*/React__default["default"].createElement(PropertySold.PropertySold, {
    width: "100%",
    height: "100%",
    __css: {
      mask: "url(".concat(mask["default"], ") center center / cover no-repeat")
    }
  }), /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
    __css: {
      position: 'absolute',
      boxSize: 'full',
      top: 0,
      left: 0
    }
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.svg, {
    width: "100%",
    height: "100%",
    viewBox: "0 0 93 93",
    __css: {
      mask: "url(".concat(mask["default"], ") center center / cover no-repeat")
    }
  }, percentage < 100 && /*#__PURE__*/React__default["default"].createElement(react.chakra.circle, {
    cx: "46.5",
    cy: "46.5",
    r: CIRCLE_RADIUS,
    __css: {
      fill: 'green.400',
      stroke: 'gray.300',
      strokeOpacity: 0.5,
      strokeWidth: 16,
      transition: "stroke-dashoffset ".concat(animationDuration, "s")
    }
  }), /*#__PURE__*/React__default["default"].createElement(react.chakra.circle, {
    cx: "46.5",
    cy: "46.5",
    r: 93 / 2 - 4,
    __css: {
      fill: 'transparent',
      stroke: 'yellow.400',
      strokeWidth: 8,
      transition: "stroke-dashoffset ".concat(animationDuration, "s"),
      strokeDasharray: "".concat(CIRCUMFERENCE, " ").concat(CIRCUMFERENCE),
      transform: 'rotate(72deg)',
      transformOrigin: '50% 50%'
    },
    style: {
      strokeDashoffset: strokeProgress
    }
  }), percentage < 100 && /*#__PURE__*/React__default["default"].createElement(react.chakra.circle, {
    cx: "46.5",
    cy: "46.5",
    r: CIRCLE_RADIUS,
    __css: {
      fill: 'green.400'
    }
  }), percentage < 100 && /*#__PURE__*/React__default["default"].createElement("text", {
    textAnchor: "middle"
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.span, {
    as: "tspan",
    y: "53.5",
    x: "47.5",
    __css: {
      fontFamily: 'body',
      fontWeight: 600,
      fill: 'white',
      fontSize: '24px'
    }
  }, value)))), /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
    __css: {
      pos: 'absolute',
      boxSize: '34.440860215%',
      bottom: 0,
      right: 0
    }
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
    __css: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSize: '100%',
      bg: 'yellow.300',
      borderRadius: 'circle'
    }
  }, /*#__PURE__*/React__default["default"].createElement(PropertyProgressIcon, {
    type: type,
    boxSize: "50%",
    color: "white"
  })))));
});
PropertyProgressIndicator.displayName = 'PropertyProgressIndicator';
exports.PropertyProgressIndicator = PropertyProgressIndicator;